import BusinessesView from "../BusinessesView.vue";
import BusinessesPage from "../Pages/BusinessesPage.vue";
import LocationsView from "../LocationsView.vue";
import LocationList from "../Pages/LocationList.vue";
import LocationEditor from "../Pages/LocationEditor.vue";

const routes = [
  {
    path: '/businesses',
    component: BusinessesView,
    children: [
      {
        path: '',
        name: 'businesses',
        component: BusinessesPage,
      },
    ]
  },
  {
    path: '/businesses/locations',
    component: LocationsView,
    children: [
      {
        path: '',
        name: 'location-list',
        component: LocationList
      },
      {
        path: 'create',
        name: 'location-create',
        component: LocationEditor
      },
      {
        path: ':id/edit',
        name: 'location-edit',
        component: LocationEditor
      }
    ]
  }
]

export default routes
